export const isEnglishWordOperator = (operator: string): boolean => {
  const symbolRegex = /[<>!=|&%^$@#*+\-\/]/;
  return !symbolRegex.test(operator) && operator.trim().length > 0;
};
